import React, {useState} from 'react';
import {Button, ColorPicker, Form, Input, Modal, Table, Tag, theme} from "antd";
import {ColumnsType} from "antd/es/table";
import {QueryKey, useQueryClient} from "@tanstack/react-query";
import {EditOutlined} from "@ant-design/icons";
import {useCommonUseMutation, useCommonUseQuery} from "../../../../../../Common/hooks/rest/ReacQueryHook";
import {procAdminService} from "../../../../../../Common/util/ProcService";
import {formatDate} from "../../../../../../Common/util/DateUtil";
import {TB_DOCUMENT_LINK_TYPE} from "../data/TB_DOCUMENT";

const LinkedKeyMgr: React.FC = () => {
    const { token: { colorBgContainer },} = theme.useToken();

    const queryClient = useQueryClient();
    const queryKey:QueryKey =   [`LinkedKeyMgr`];

    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;

    const mutateUpdate = useCommonUseMutation<any>(queryKey, queryClient
        , procAdminService);

    const { data, isFetching} = useCommonUseQuery<TB_DOCUMENT_LINK_TYPE[]>(
        queryKey,
        () =>procAdminService<TB_DOCUMENT_LINK_TYPE[]>("post", `${serviceCode}ADS28`, null));

    const [linkTypeCD, setLinkTypeCD] = useState<string>('');
    const [linkTypeName, setLinkTypeName] = useState<string>('');
    const [regUser, setRegUser] = useState<string>('');
    const [boxColor, setBoxColor] = useState<string>('');
    const [lineColor, setLineColor] = useState<string>('');
    const [showConfirmBox, setShowConfirmBox] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [isModifyMode, setIsModifyMode] = useState<boolean>(false);


    const columns: ColumnsType<TB_DOCUMENT_LINK_TYPE> = [
        {
            title: '종류코드',
            dataIndex: 'linkTypeCD',
            key: 'linkTypeCD',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '종류명',
            dataIndex: 'linkTypeName',
            key: 'linkTypeName',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: 'Box 색상',
            dataIndex: 'boxColor',
            key: 'boxColor',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ColorPicker value={text}  disabled defaultValue={text}/>
                </div>

        },
        {
            title: 'Line 색상',
            dataIndex: 'lineColor',
            key: 'lineColor',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ColorPicker value={text} disabled defaultValue={text}/>
                </div>

        },
        {
            title: '생성일자',
            key: 'firstRegTime',
            dataIndex: 'firstRegTime',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>

        },
        {
            title: '수정일자',
            key: 'lastRegTime',
            dataIndex: 'lastRegTime',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>
            ,
        },
        {
            title: '',
            key: 'Active',
            dataIndex: 'Active',
            render: (text, record:TB_DOCUMENT_LINK_TYPE) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button type="link" size="small" onClick={() => { openModifyModal(record); }}>수정</Button>
                    <Button type="link" size="small" onClick={() => { onDelete(record); }}>삭제</Button>
                </div>

        },

    ];


    const onDelete = (record:TB_DOCUMENT_LINK_TYPE) => {

        Modal.confirm({
            title: `${record.linkTypeName}을(를) 삭제하시겠습니까?`,
            content: "주의 : 시스템에 영향이 미칠 수 있습니다.",
            open: showConfirmBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowConfirmBox(false);
                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADD05`, requestBody:record }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);
                    }).finally(() => {
                    });
            },
            onCancel() {
                setShowConfirmBox(false);
            },
        });

    };



    function openRegModal()
    {
        setLinkTypeCD('');
        setLinkTypeName('');
        setRegUser('');
        setBoxColor('#E0F1FF');
        setLineColor('#25A5EC');
        setShowModal(true);
        setIsModifyMode(false);
    }

    function openModifyModal(recode:TB_DOCUMENT_LINK_TYPE)
    {
        setLinkTypeCD(recode.linkTypeCD);
        setLinkTypeName(recode.linkTypeName);
        setRegUser(recode.regUser);
        setBoxColor(recode.boxColor);
        setLineColor(recode.lineColor);
        setShowModal(true);
        setIsModifyMode(true);
    }

    function onSaveArchive()
    {
        const requestParam:TB_DOCUMENT_LINK_TYPE = {
            linkTypeCD:linkTypeCD,
            linkTypeName:linkTypeName,
            regUser:regUser,
            boxColor:boxColor,
            lineColor:lineColor,
            linkTypeStatus:'1',
        }
        Modal.confirm({
            title: `${linkTypeName}을(를) 저장하시겠습니까?`,
            content: "",
            open: showConfirmBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowConfirmBox(false);
                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADU12`, requestBody:requestParam }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);

                    }).finally(() => {
                        setShowModal(false);
                    });
            },
            onCancel() {
                setShowConfirmBox(false);
            },
        });
    }



    const fields = [
        { name: ['linkTypeCD'], value: linkTypeCD },
        { name: ['linkTypeName'], value: linkTypeName },
        { name: ['boxColor'], value: boxColor },
        { name: ['lineColor'], value: lineColor },
    ];


    return (
        <>
            <nav style={{
                margin:'0px 0px 14px 0px',
                padding:'9px 8px 9px 0px',
                height: '50px',
                display:'flex',
                justifyContent: "space-between",
                alignItems:'center',
                borderRadius: "8px", // 라운드 처리 추가
                border: '1px solid #dadada',
                background: colorBgContainer,
            }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{
                        padding: '9px 5px',
                        display:'flex',
                    }}>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Button style={{marginRight:"10px"}} type={"primary"} onClick={openRegModal}>연결코드등록</Button>
                </div>
            </nav>
        <Table columns={columns}
            dataSource={data}
            rowKey="docTypeCode"
            loading={isFetching}
        />

            <Modal
                open={showModal}
                title="연결코드저장"
                onCancel={()=>{setShowModal(false)}}
                footer={[
                    <></>
                ]}
            >
                <Form
                    fields={fields}
                    name="saveArchive"
                    initialValues={{
                        remember: false,
                    }}
                    onFinish={onSaveArchive}
                >
                    <Form.Item
                        label={"연결코드"}
                        name="linkTypeCD"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        {
                            isModifyMode ?
                                <Input
                                    readOnly
                                    prefix={<EditOutlined className="site-form-item-icon" />}
                                    placeholder="연결코드"
                                    value={linkTypeCD}
                                    onChange={(e)=>setLinkTypeCD(e.target.value)}
                                />
                                :
                                <Input
                                    prefix={<EditOutlined className="site-form-item-icon" />}
                                    placeholder="연결코드"
                                    value={linkTypeCD}
                                    onChange={(e)=>setLinkTypeCD(e.target.value)}
                                />
                        }


                    </Form.Item>
                    <Form.Item
                        label={"연결코드명"}
                        name="linkTypeName"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="연결코드명"
                            value={linkTypeName}
                            onChange={(e)=>setLinkTypeName(e.target.value)}
                        />

                    </Form.Item>
                    <Form.Item
                        label={"Box 색상"}
                        name="boxColor"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <ColorPicker showText defaultValue={boxColor} value={boxColor} onChange={(value, hex)=>{ setBoxColor(hex)}}/>

                    </Form.Item>
                    <Form.Item
                        label={"Line색상"}
                        name="lineColor"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <ColorPicker showText defaultValue={lineColor} value={lineColor} onChange={(value, hex)=>{ setLineColor(hex)}}/>

                    </Form.Item>
                    <Form.Item
                        label={"미리보기"}
                        name="preview"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Tag style={{fontSize:"11px"
                            , border:`1px solid ${lineColor}`
                            , color:`${lineColor}`}}
                            bordered={true} color={boxColor} >테스트코드:TEST0000001</Tag>

                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button">
                            적용
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default LinkedKeyMgr;
